export default "__VITE_ASSET__Dpl9Rj$V__"